import { useInfiniteQuery, useQueryClient } from "@tanstack/react-query";
import { getDirectorAudit } from "../api";
import { useEffect } from "react";

export function useDirectorAudit(
  directorId: string,
  enabled = true,
  tab?: string,
) {
  const queryClient = useQueryClient();

  // Explicitly clear cache when this hook is no longer needed (component unmounts)
  useEffect(() => {
    return () => {
      queryClient.removeQueries({
        queryKey: ["director-audit", directorId],
      });
    };
  }, [queryClient, directorId]);

  return useInfiniteQuery({
    queryKey: ["director-audit", directorId, tab],
    queryFn: async ({ pageParam = 1 }) => {
      const response = await getDirectorAudit(
        directorId,
        pageParam as number,
        20,
        tab,
      );
      return {
        data: response.data,
        pagination: response.pagination,
        nextPage:
          pageParam < response.pagination.totalPages
            ? (pageParam as number) + 1
            : undefined,
      };
    },
    getNextPageParam: (lastPage) => lastPage.nextPage,
    initialPageParam: 1,
    enabled: enabled && !!directorId,
    refetchOnMount: "always",
    staleTime: 0,
    gcTime: 0,
    refetchOnWindowFocus: false,
  });
}
